import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import 'react-lazy-load-image-component/src/effects/blur.css';
import Style from '../Styles/Common.module.css';
import constants from '../../services/constants';
const AbouMayoBanner = (props)=>{
  
  const imageData = props.SliderImage
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
          },
          tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
          },
          mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
          }
      };
     
    return(
        <section className={Style.aboutmayo}>
          <div className={Style.pageTitle + ' ' + Style.mayoajmer}>
           <Container fluid={true}>
                <Row>
                    <Col md={12}>
                        <div className={Style.sectionTitle}>
                            <h2>About MAYO</h2>
                        </div>
                    </Col>
                    <Col lg={5} className={Style.padd0}>
                        <div className={Style.amjerlogo}>
                            <img alt="" src={require('../../assest/images/mayo-ajmer-logo.png')}/>
                            <h2>Mayo College <span>Ajmer, India</span></h2>
                        </div>
                    </Col>
                      <Col lg={7} className={Style.padd0}>
                        <Carousel autoPlay={true} autoPlaySpeed={3000} infinite={true} responsive={responsive}showDots={true} pauseOnHover={false} removeArrowOnDeviceType={['desktop','tablet', 'mobile']}>
                          {imageData.map((item)=>{
                            return(
                              <div key={item._id}>
                                  <img effect='blur' src={constants.IMAGE_BASE_URL_WITHOUT_UPLOAD+'/'+item.image}/>
                              </div>
                            )
                          })}
                        </Carousel>
                    </Col>
                </Row>
            </Container>
          </div>
        <div className={Style.aboutmayocollege +" "+Style.clear}>
           <Container>
                <Row>
                    <Col >
                        <p><strong>Mayo College is a residential public school in Ajmer, Rajasthan, India. It was founded in 1875 by Richard Bourke, 6th Earl of Mayo who was also the Viceroy of India from 1869 to 1872. The school is one of the oldest public boarding schools of India.</strong></p>
                        <p>The College was opened in October 1875, with Sir Oliver St.John as the first Principal and one boy, Maharaja Mangal Singh of Alwar. Nicknamed the 'Eton of the East', was established to provide modern education to the aristocracy. For last 70 years the school has been following an egalitarian philosophy and accepts students from all communities and regions across the nation and the world.</p>
                        <p>Mayo College is considered among the better known boarding schools in the world and is affiliated to the Central Board of Secondary Education - CBSE. The School has 12 Boarding Houses - 8 Senior Houses, 1 Holding House & 3 Junior Houses, home to over 800 boys from Class IV to XII.</p>
                        <h3>VISION</h3>
                        <p style={{textAlign:'center'}}>Build on tradition and prepare global leaders with character.</p>
                        <h3>SCHOOL PHILOSOPHY</h3>
                        <p>Students come from all parts of India and neighboring countries and live harmoniously in age diverse and culturally diverse boarding houses. The emphasis is on being 'outdoors', education through 'exploration', interdisciplinary teaching and teaching beyond classroom. Students are groomed to be Independent, Doers, Enablers, Collaborators, Team players and Leaders. The students live on campus in non air conditioned environment and grow to become resilient. The focus is on holistic all round development and not on rote learning for examinations.</p>
                        <ul>
                            <li>A 187 acre campus</li>
                            <li>More than 20 Sports</li>
                            <li>More than 30 Hobby & Co-Curricular Clubs</li>
                            <li>Robotics</li>
                            <li>3 D printing</li>
                            <li>Drone Photography</li>
                            <li>Carpentry</li>
                            <li>Metalwork</li>
                            <li>Glasswork</li>
                            <li>NCC</li>
                        </ul>
                        <ul>
                            <li>Organic Farming</li>
                            <li>Community Service</li>
                            <li>Photography</li>
                            <li>Debating</li>
                            <li>MUN</li>
                            <li>Theatre</li>
                            <li>Music School with a Brass Band, a Western Band, a School Choir and an Indian Orchestra</li>
                            <li>Art School with expert faculty in Fine Arts, Sculpting (In various mediums), Screen Printing, Carpet weaving, Recycled Paper making, etc</li>
                        </ul>
                        <p><strong>Give your child the advantage of Mayo and discover why generations of Mayoites are so proud of their Alma Mater!</strong></p>
                   </Col>
                </Row>
            </Container>
        </div>
        </section>        
    )
}

export default AbouMayoBanner;